import { supabase } from "@/integrations/supabase/client";
import { useToast } from "@/hooks/use-toast";
import { ChatMessage, ConversationState } from "@/components/agent/chat/types";

export const useConversationReset = (
  agent: any,
  isPublic: boolean,
  isLoading: boolean,
  chatMessages: ChatMessage[],
  setChatMessages: (messages: ChatMessage[]) => void,
  conversationId: string | null,
  setConversationId: (id: string | null) => void,
  setPreviousResponseId: (id: string | null) => void,
  setConversationState?: (state: ConversationState) => void
) => {
  const { toast } = useToast();

  const handleResetConversation = async () => {
    if (isLoading) return;

    setChatMessages([]);
    setPreviousResponseId(null);

    if (setConversationState) {
      setConversationState("open");
    }

    if (isPublic) {
      localStorage.removeItem(`public_chat_${agent.public_id}`);
      setConversationId(null);

      if (agent.welcome_message) {
        const welcomeMessage: ChatMessage = {
          type: "agent",
          content: agent.welcome_message,
          timestamp: new Date().toISOString(),
        };
        setChatMessages([welcomeMessage]);
      }
    } else if (conversationId) {
      try {
        await supabase
          .from("messages")
          .delete()
          .eq("conversation_id", conversationId);

        if (agent.welcome_message) {
          const welcomeMessage: ChatMessage = {
            type: "agent",
            content: agent.welcome_message,
            timestamp: new Date().toISOString(),
          };
          setChatMessages([welcomeMessage]);

          const { data } = await supabase
            .from("messages")
            .insert({
              conversation_id: conversationId,
              content: agent.welcome_message,
              role: "assistant",
            })
            .select();

          if (data && data[0].openai_message_id) {
            setPreviousResponseId(data[0].openai_message_id);
          }
        }
      } catch (error) {
        console.error("Error resetting conversation:", error);
        toast({
          variant: "destructive",
          title: "Error",
          description: "Failed to reset conversation. Please try again.",
        });
      }
    }
  };

  const canResetConversation =
    chatMessages.length > (agent.welcome_message ? 1 : 0);

  return {
    canResetConversation,
    handleResetConversation,
  };
};
